import { ease } from '../../application/utils/ease'
import './filter.component.scss'
import { matchMedia } from '../../application/utils/machMedia'
import { enableBodyScroll, disableBodyScroll } from 'body-scroll-lock'

const filter = document.querySelector('aside.filter')
const filterStateControl = document.querySelector(
  '.filter-state-control button'
)

function orientationChangeHandler(e) {
  if (!e.matches) {
    enableBodyScroll(filter)
    document.documentElement.classList.remove('is-filter-active')
  }
}

document.addEventListener('click', ({ target }) => {
  if (target.closest('.filter-item__heading')) {
    const root = target.closest('.filter-item')
    const container = root.querySelector('.filter-item__content')
    if (root) {
      const toggleResult = root.classList.toggle('is-active')
      if (toggleResult) {
        ease.show(container)
      } else {
        ease.hide(container)
      }
    }
  }
})

document.querySelectorAll('.filter-item.is-active').forEach(root => {
  if (root.classList.contains('filter-item__content')) {
    ease.show(root.querySelector('.filter-item__content'))
  }
})
if (filter && filterStateControl) {
  matchMedia('(orientation: portrait)')(orientationChangeHandler)
  filterStateControl.addEventListener('click', () => {
    const isActive = document.documentElement.classList.toggle(
      'is-filter-active'
    )
    if (isActive) {
      disableBodyScroll(filter)
    } else {
      enableBodyScroll(filter)
    }
  })
}
function openActiveFilters() {
  const filters = document.querySelectorAll('.filter-item.is-active')
  filters.forEach(filter => {
    const container = filter.querySelector('.filter-item__content')
    if (container) {
      ease.show(container)
    }
  })
}
openActiveFilters()
